<div class="col-12 container" *ngIf="messageText">
  <div class="justify-content-center d-flex mt10 alertMessage">
    <div id="searchServiceError" class="alert alert-info" role="alert">
      <p [innerHTML]="messageText"></p>
    </div>
  </div>
</div>